import sha256 from "crypto-js/sha256";

export const toSha256Legacy = (password) => {
  return sha256(password).toString().toUpperCase();
};
